module.exports = __webpack_public_path__ + "img/ygw.72c8f1ef.jpg";